// @flow
import { find } from 'lodash'
import type { ID } from 'app/core/types'

export const getElementSubscription = (state: Object, elementId: ID): any => {
  return find(state.subscriptions.resources, (subscription) => subscription.targetId === elementId)
}
